import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { photoAction } from "../../_store";

const ScrollableCard = ({ children }) => {
  const [showButton, setShowButton] = useState(false);
  const cardRef = useRef(null);
  const location = useLocation();
  const { isPageScroll } = useSelector((state) => state.revenueReporting);

  useEffect(() => {
    const handleScroll = () => {
      if (cardRef.current) {
        setShowButton(cardRef.current.scrollTop > 100);
      }
    };

    if (cardRef.current) {
      cardRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (cardRef.current) {
        cardRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);


  // Scroll to top when route changes
  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname, isPageScroll]);

  const scrollToTop = () => {
    if (cardRef.current) {
      cardRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <div ref={cardRef} className="scrollCard">
        {children}
      </div>

      {showButton && (
        <button
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          title="Back to Top"
        >
          <i className="fa-regular fa-circle-up"></i>
        </button>
      )}
    </div>
  );
};

export default ScrollableCard;
